import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';
import { ShowQuestionnaireResultModel } from 'src/app/model/insurance-questionnaire.model';

export const QuestionnaireWordingRequestAction = createAction('[Insurance Questionnaire view] get wording', props<{accountId:number}>());
export const QuestionnaireWordingResponseAction = createAction('[Insurance Questionnaire view] set wording', props<{wording:{[key:string]:string}}>());

export const ShowQuestionnaireRequestAction = createAction('[Insurance Questionnaire view] show questionnaire', props<{ accountId: number }>());
export const ShowQuestionnaireResponseAction = createAction('[Insurance Questionnaire view] show questionnaire response', props<{ payload: ShowQuestionnaireResultModel }>());